<template>
  <b-form-group>
    <b-form-radio-group
      v-model="scheduleSettings.ScheduleType"
      stacked
      :disabled="disabled"
    >
      <b-form-radio value="Once">
        {{ $t("Webportal.NotificationSettings.OnceDaily") }}
        <dx-date-box
          v-model="scheduleSettings.ScheduleTime"
          type="time"
          class="custom-control-inline"
          width="6em"
          height="2em"
          @valueChanged="scheduledTimeValueChanged($event)"
          :use-mask-behavior="true"
          displayFormat="HH:mm"
          :disabled="disabled || scheduleSettings.ScheduleType != 'Once'"
        />
      </b-form-radio>
      <b-form-radio value="EveryHour" class="mt-2">
        {{ $t("Webportal.NotificationSettings.Every") }}
        <dx-number-box
          v-model="scheduleSettings.ScheduleHours"
          class="custom-control-inline"
          width="5em"
          height="2em"
          format="#0"
          :show-spin-buttons="true"
          :step="1"
          :min="1"
          :max="23"
          :disabled="disabled || scheduleSettings.ScheduleType != 'EveryHour'"
        />
        {{
          scheduleSettings.ScheduleHours > 1
            ? $t("Webportal.NotificationSettings.Hours")
            : $t("Webportal.NotificationSettings.Hour")
        }}
      </b-form-radio>
      <b-form-radio value="Instantly" class="mt-2">
        {{ $t('Webportal.NotificationSettings.Instantly') }}
        <small>({{ $t('Webportal.NotificationSettings.Instantly.Description') }})</small>
      </b-form-radio>
    </b-form-radio-group>
  </b-form-group>
</template>

<script>
import moment from "moment";
import { DxDateBox, DxNumberBox } from "devextreme-vue";

export default {
  name: "ScheduleInput",

  components: {
    DxDateBox,
    DxNumberBox,
  },

  props: {
    value: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      internalValue: this.value,
      scheduleSettings: {
        ScheduleType: "Once",
        ScheduleTime: moment().hours(18).minutes(0).toDate(), // 18:00
        ScheduleHours: 4,
      },
    };
  },

  watch: {
    value(newVal) {
      if (newVal !== this.internalValue) {
        this.internalValue = newVal;

        if (newVal != null) this.parseCronSchedule();
        else this.onInput(this.cronValue);
      }
    },

    cronValue(newVal) {
      this.onInput(newVal);
    },
  },

  computed: {
    cronValue() {
      let m = moment(this.scheduleSettings.ScheduleTime).utc();

      if (this.scheduleSettings.ScheduleType === "Once")
        return `0 ${m.minutes()} ${m.hours()} ? * *`;
      else if (this.scheduleSettings.ScheduleType === "Instantly")
        return "* * * ? * *";
      else return `0 0 0/${this.scheduleSettings.ScheduleHours} ? * *`;
    },
  },

  created() {
    // Either parse initial value or set default value
    if (this.value != null) this.parseCronSchedule();
    else this.onInput(this.cronValue);
  },

  methods: {
    onInput(value) {
      this.internalValue = value;
      this.$emit("input", value);
    },

    parseCronSchedule() {
      const cronParts = this.internalValue ? this.internalValue.split(" ") : [];

      if (cronParts.length >= 3) {
        const hourPart = cronParts[2];

        if (this.internalValue === "* * * ? * *") {
          this.scheduleSettings.ScheduleType = "Instantly";
        } else if (!hourPart.includes("/")) {
          this.scheduleSettings.ScheduleType = "Once";
          this.scheduleSettings.ScheduleTime = moment
            .utc()
            .hours(Number(hourPart))
            .minutes(Number(cronParts[1]))
            .local()
            .toDate();
        } else {
          this.scheduleSettings.ScheduleType = "EveryHour";
          this.scheduleSettings.ScheduleHours = Number(hourPart.split("/")[1]);
        }
      }
    },

    scheduledTimeValueChanged(event) {
      const scheduleTime = moment(this.scheduleSettings.ScheduleTime);
      const remainder = scheduleTime.minutes() % 15;

      if (remainder !== 0)
        this.scheduleSettings.ScheduleTime = scheduleTime
          .add(15 - remainder, "minutes")
          .toDate();
    },
  },
};
</script>